import {ChangeDetectionStrategy, Component, Inject, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {bzIconTimeZone} from '@bringoz/ui/icons';

require('./bringoz-time-window-tooltip.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-time-window-tooltip',
  templateUrl: './bringoz-time-window-tooltip.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozTimeWindowTooltipComponent implements OnInit, OnChanges {

  readonly icons = {timeZone: bzIconTimeZone};

  @Input() notBefore: any;
  @Input() notAfter: any;
  @Input() timeZoneId: string;
  @Input() configZoneId: string;
  @Input() isTooltip: boolean;

  public timeZoneOffsetDiff: number;

  constructor(@Inject('splitService') private splitService) {
  }

  ngOnInit() {
    this.checkTimeZoneOffsetDiff();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.notBefore && !changes.notBefore.isFirstChange()) {
      this.checkTimeZoneOffsetDiff();
    }

    if (changes.notAfter && !changes.notAfter.isFirstChange()) {
      this.checkTimeZoneOffsetDiff();
    }

    if (changes.configZoneId && !changes.configZoneId.isFirstChange()) {
      this.checkTimeZoneOffsetDiff();
    }
  }

  checkTimeZoneOffsetDiff() {
    this.timeZoneOffsetDiff = this.splitService.getTimeZoneOffsetDiff(this.timeZoneId, this.notBefore);
    return this.timeZoneOffsetDiff !== 0;
  }

}
